<template>
    <div>
        <card>
            <h1 style="color:#00467f;margin-top:15px;text-align:left"><strong>Corsi di formazione</strong></h1>
            <!-- <div id="containerid"></div> -->
            <!-- <hr> -->
            <!-- <VueCustomTooltip :label="val1+'/100'" >
                <vue-awesome-progress
                    circle-color="#e5e9f2"
                    :circle-width="4"
                    :line-width="4"
                    :circle-radius="35"
                    :point-radius="0"
                    :start-deg="270"
                    :percentage="val1"
                    :line-color="(val1 < 50 && val1 < 80) ? '#FF0000' : (val1 >= 50 && val1<= 80 ) ? '#ffff00' : '#00FF00'"
                    /> 
            </VueCustomTooltip>
            -->
            <div class="row">
                <div class="col">
                    <p style="text-align:left; margin-left:20px">FILTRA PER:<br>
                        <ul style="list-style-type: none;">
                            <li><label style="color:black"><input type="radio" id="dataScadenza" value="dataScadenza" v-model="filtroScelto" style="text-align:left; margin-right:10px">DATA SCADENZA</label>
                            <div class="row" style="margin-left:10px;margin-bottom:25px" v-if="filtroScelto == 'dataScadenza'">
                                <div class="col">
                                <p><strong>Prima di</strong><input type="date" class="form-control" value="17-06-2021" id="dateFrom" v-model="dataScadenza" v-on:keyup.enter="cercaData()"/></p>
                                </div>
                                <div class="col">
                                <button class="btn btn-primary" type="button" v-on:click="cercaData()" style="background:#00467f;margin-top:15px">Cerca</button>
                                </div>
                            </div>
                            </li>
                            <li>
                                <label style="color:black"><input type="radio" id="dataDaA" value="intervalloDataCorso" v-model="filtroScelto" style="text-align:left; margin-right:10px">DATA CORSO</label>
                                <div class="row" style="margin-left:10px;margin-bottom:25px" v-if="filtroScelto == 'intervalloDataCorso'">
                                    <div class="col-4">
                                        <label>compresa tra</label><input type="date" class="form-control" id="dateFrom" v-model="dateCorsoFrom" v-on:keyup.enter="cercaData()"/>
                                    </div>
                                    <div class="col-4">
                                        <label>e</label><input type="date" class="form-control" id="dateTo" v-model="dateCorsoTo" v-on:keyup.enter="cercaData()"/>
                                    </div>
                                    <div class="col-4">
                                        <button class="btn btn-primary" type="button" v-on:click="cercaData()" style="background:#00467f;margin-top:15px">Cerca</button>
                                    </div>
                                </div>
                            </li>
                            <li><label style="color:black"><input type="radio" value="filtraDocente" v-model="filtroScelto" id="filtraDocente" style="text-align:left; margin-right:10px">DOCENTE</label>
                                <div class="row" v-if="filtroScelto == 'filtraDocente'">
                                    <div class="col">
                                    <input type="text" class="form-control" id="docente" v-model="cerca_docente" placeholder="Rossi" style="margin-left:15px;margin-top:5px" v-on:keyup.enter="filterByDocente()"/><!--  -->
                                    </div>
                                    <div class="col">
                                    <button class="btn btn-primary" type="button" v-on:click="filterByDocente()" style="background:#00467f">Cerca</button>
                                    </div>
                                </div>
                            </li>
                            <li><label style="color:black"><input type="radio" value="filtraCodiceCorso" v-model="filtroScelto" style="text-align:left; margin-right:10px">CODICE CORSO</label>
                                <div class="row" v-if="filtroScelto == 'filtraCodiceCorso'">
                                    <div class="col">
                                    <input type="text" class="form-control" v-model="filtra_codice_corso" style="margin-left:15px;margin-top:5px" v-on:keyup.enter="filterByCodiceCorso()"/>
                                    </div>
                                    <div class="col">
                                    <button class="btn btn-primary" type="button" v-on:click="filterByCodiceCorso()" style="background:#00467f">Cerca</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </p>
                </div>
                <div class="col">
                    <span class="float-right">
                        <div class="search-bar input-group"  @click="searchModalVisible = true">
                            <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
                            <span class="d-lg-none d-md-block">Search</span>
                            </button>
                        </div>
                        <modal :show.sync="searchModalVisible" class="modal-search" id="searchModal" :centered="false" :show-close="true">
                            Cerca per:<br>
                            <label for="nome_corso" style="margin-right:10px"><input type="radio" id="nome_corso" value="nome_corso" v-model="cerca_selezionato" style="margin-right:5px">nome corso</label>
                            <label for="codice_corso"><input type="radio" id="codice_corso" value="codice_corso" v-model="cerca_selezionato" style="margin-right:5px">codice corso</label>
                            <label for="docente_corso"><input type="radio" id="docente_corso" value="docente_corso" v-model="cerca_selezionato" style="margin-right:5px">docente corso</label>
                            <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
                        </modal>
                    </span>
                </div>
            </div>
            <div class="row" style="margin-top:10px">
                <div style="margin-left:80px;font-weight:bold">
                    <label>Numero di righe per pagina:</label>
                    <select v-model="n_righe" v-on:change="caricaPagina()" style="border: 2.5px solid;border-radius:0.25em;border-color:#00467f;background-color: #fff;width:100%;max-width: 100px;margin-left:30px">
                        <option disabled value="">Please select one</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div class="row justify-content-center" style="margin-bottom:30px;margin-top:20px">
              <div class="col-4">
                <div v-if="page != 1"><button v-on:click="changePage('indietro')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-left" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
              <div class="col-4">
                <p>Pagina <strong>{{page}}</strong> di <strong>{{totPage}}</strong></p>
              </div>
              <div class="col-4">
                <div v-if="page < totPage"><button v-on:click="changePage('avanti')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-right" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
            </div>
            <table class="table tablesorter" id="tabella" style="text-align:center">
                <thead>
                    <tr>
                        <th @click="sort('CODICE_CORSO')" style="text-decoration:underline">CODICE CORSO</th>
                        <th>NOME CORSO</th>
                        <!-- <th>DATA CREAZIONE</th> -->
                        <th @click="sort('DATA_CORSO')" style="text-decoration:underline">DATA INIZIO</th>
                        <th>NUMERO ISCRITTI/CAPIENZA %</th>
                        <th>SEDE</th>
                        <th>AULA</th>
                        <th @click="sort('DATA_SCADENZA')" style="text-decoration:underline">DATA SCADENZA</th>
                        <th @click="sort('COSTO')" style="text-decoration:underline">COSTO</th>
                        <th @click="sort('DOCENTE')" style="text-decoration:underline">DOCENTE</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="row-color" v-for="(valori) in sortedCorsi" v-bind:key="valori.ID"><!-- corsi  -->
                        <td>{{valori.CODICE_CORSO}}</td>
                        <td>{{valori.C_CORSO.NOME}}</td>
                        <!-- <td>{{getDate(valori.DATA_CREAZIONE)}}</td> -->
                        <td>{{getDate(valori.DATA_CORSO)}}</td>
                        <td :id="'container'+valori.ID">
                            <!--  v-if="valori.C_AULA.CAPIENZA != null" -->
                            <VueCustomTooltip :label="valori.N_ISCRITTI+'/'+valori.C_AULA.CAPIENZA">
                                <vue-awesome-progress
                                    circle-color="#e5e9f2"
                                    :circle-width="4"
                                    :line-width="4"
                                    :circle-radius="35"
                                    :point-radius="0"
                                    :start-deg="270"
                                    :percentage="valori.N_ISCRITTI/valori.C_AULA.CAPIENZA*100"
                                    :line-color="(valori.N_ISCRITTI/valori.C_AULA.CAPIENZA*100 < 50 && valori.N_ISCRITTI/valori.C_AULA.CAPIENZA*100 < 80) ? '#FF0000' : (valori.N_ISCRITTI/valori.C_AULA.CAPIENZA*100 >= 50 && valori.N_ISCRITTI/valori.C_AULA.CAPIENZA*100<= 80 ) ? '#ffff00' : '#00FF00'"
                                    />
                            </VueCustomTooltip>
                            <!-- <vue-awesome-progress v-else
                                circle-color="#e5e9f2"
                                :circle-width="4"
                                :line-width="4"
                                :circle-radius="35"
                                :point-radius="0"
                                :start-deg="270"
                                :percentage="valori.N_ISCRITTI"
                                :line-color="(valori.N_ISCRITTI < 50 && valori.N_ISCRITTI < 80) ? '#FF0000' : (valori.N_ISCRITTI >= 50 && valori.N_ISCRITTI<= 80 ) ? '#ffff00' : '#00FF00'"
                                /> -->
                        </td>
                        <!-- <td>{{valori.N_ISCRITTI}}</td> -->
                        <td>{{valori.C_AULA.INDIRIZZO}}</td>
                        <td>{{valori.C_AULA.NOME}}</td>
                        <td>{{getDate(valori.DATA_SCADENZA)}}</td>
                        <td>{{valori.COSTO}} €</td>
                        <td>{{valori.DOCENTE}}</td>
                        <td><router-link :to="'/modifica-corso?id='+valori.ID"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link></td>
                    </tr>
                </tbody>
            </table>
        </card>
        
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import CorsoServices from '@/services/CorsoServices';
import Modal from "@/components/Modal.vue"; //per la lente ricerca
import moment from 'moment';
import VueAwesomeProgress from "vue-awesome-progress";
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';

export default {
    components: {
      Card, Modal, VueAwesomeProgress, VueCustomTooltip
    },
  
    data() {
        return {
            val1: 50,
            color: '#FF0000',
            searchModalVisible: false,
            cerca_selezionato: 'codice_corso',
            corsi: [],
            allCorsi: [],
            n_righe: 15,
            dataScadenza: null,
            dateCorsoFrom: null,
            dateCorsoTo: null,
            access_token: null,
            filtroScelto: 'dataScadenza',
            cerca_docente: null,
            filtra_codice_corso: null,
            page: 1,
            totPage: null,
            token_response: [],
            user_livello: null,

            currentSort:'DATA_CORSO',
            currentSortDir:'desc',
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'
        }
    },
    methods: {
        // per prendere tutti i corsi
        caricaCorsi: async function() {
            let errore = 0;
            await CorsoServices.getCorsi()
            .then(response => { this.allCorsi = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.caricaCorsi(); }
            }
            console.log("tutti i corsi: ");
            console.log(this.allCorsi);
        },

        caricaPagina: async function(){
            let risposta;
            let errore = 0;
            await CorsoServices.changePage(1, this.n_righe)
            .then(response => { risposta = response.data})
            .catch( async function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                    console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.caricaPagina(); }
            }
            this.corsi = risposta.rows;
            // Faciamo che ne mostro 15 per pagina
            var total = this.allCorsi.length;
            this.totPage = Math.ceil(total/this.n_righe);
        },

        cerca: async function() {
            let i, txtValue;
            let input = document.getElementById("ricerca");
            let filter = input.value.toUpperCase();
            let table = document.getElementById("tabella");
            let tr = table.getElementsByTagName("tr");
            let arrayFiltrato = [];
            console.log(`filter = ${filter}`);
            for (i = 0; i < this.allCorsi.length; i++) {
                if (this.cerca_selezionato == "codice_corso") {
                    txtValue = this.allCorsi[i].CODICE_CORSO;
                    console.log(`txtValue = ${txtValue}`);
                } 
                else if (this.cerca_selezionato == "docente_corso") {
                    txtValue = this.allCorsi[i].DOCENTE;
                    console.log(`txtValue = ${txtValue}`);
                }
                 else {
                    txtValue = this.allCorsi[i].C_CORSO.NOME;
                    console.log(`txtValue = ${txtValue}`);
                }
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                arrayFiltrato.push(this.allCorsi[i]);
                }
            }
            this.corsi = arrayFiltrato;
            console.log(`corsi filtrati`);
            console.log(this.corsi);
            if (filter == "") {
                await this.caricaPagina();
            }
        },

        cercaData: async function() {
            if (this.filtroScelto == 'dataScadenza') {
                let data = this.dataScadenza;
                let arrayFiltratoData = this.allCorsi.filter( function(el) { return el.DATA_SCADENZA <= data});
                this.corsi = arrayFiltratoData;
                console.log("array friltrato tra intervallo data: ");
                console.log(arrayFiltratoData);  
            } else if ( this.filtroScelto == 'intervalloDataCorso') {
                let dataFrom = this.dateCorsoFrom;
                let dataTo = this.dateCorsoTo;
                console.log(`dateCorsoTo: ${this.dateCorsoTo}`);
                console.log(`dataFrom: ${dataFrom}, dataTo: ${dataTo}`);
                let arrayFiltratoFrom = this.allCorsi.filter( (el) => { return el.DATA_CORSO >= dataFrom });
                console.log("arrayFiltratoFrom");
                console.log(arrayFiltratoFrom);
                let arrayFiltratoTo = arrayFiltratoFrom.filter( (el) => { return el.DATA_CORSO <= dataTo });
                this.corsi = arrayFiltratoTo;
                console.log(`array filtrato tra intervallo data corso:`);
                console.log(this.corsi);
            }
        },

        changePage: async function(val){
            let risposta;
            let errore = 0;
            if(val == 'avanti'){
                this.page = this.page + 1;
            } else {
                //indietro
                this.page = this.page - 1;
            }
            await CorsoServices.changePage(this.page, this.n_righe)
            .then(response => { risposta = response.data})
            .catch( async function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.changePage(val); }
            }
            this.corsi = risposta.rows;
        },

        filterByCodiceCorso: async function() {
            let codice_corso =  this.filtra_codice_corso;
            if (  codice_corso == '') {
                await this.caricaPagina();
            } else {
                let arrayFiltrato = this.allCorsi.filter((el) => { return el.CODICE_CORSO.toLowerCase().includes(codice_corso.toLowerCase()) == true});
                this.corsi = arrayFiltrato;
                console.log("array filtrato per codice corso");
                console.log(this.corsi);
            }
        },

        filterByDocente: async function() {
            let docente = this.cerca_docente;
            if (this.cerca_docente == '') {
                await this.caricaPagina();
            } else {
                // let arrayFiltrato = this.corsi.filter( function(el) { return el.DOCENTE == this.cerca_docente});
                let arrayFiltrato = this.allCorsi.filter( function(el) { return el.DOCENTE.toLowerCase().includes(docente.toLowerCase()) == true});
                this.corsi = arrayFiltrato;
                console.log("array filtrato per docente");
                console.log(this.corsi);
            }
        },

        getDate(date) {
            return moment(String(date)).format('DD/MM/YYYY');
        },

        refreshToken: async function(){
            let errore = 0;
            let refreshToken = localStorage.getItem('refresh_token');
            let dati = [{ refreshToken: refreshToken}];
            let datiJSON = JSON.stringify(dati[0])
            await Services.refreshToken()
            .then(response => { this.token_response = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 403){
                errore = error.response.status;
                } else if (error.response.status == 401) {
                errore = error.response.status;
                }
            });
            console.log(`errore fuori da catch refreshToken = ${errore}`);
            if(errore == 403 || errore == 401){
                console.log(`errore = ${errore} -> fai logout`);
                await this.logout();
                return false;
            } 
            localStorage.setItem('access_token', this.token_response.accessToken);
            return true;
        },
        
        sort:function(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
        },
        
        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            axios.defaults.withCredentials = true;
            this.access_token = localStorage.getItem('access_token');
            try {
                // DEVONO RESTARE IN QUESTO ORDINE ALTRIMENTI NON HO NUMERO TOTALE DEI CORSI E QUINDI VIENE PAGINA 1 DI 0
                await this.caricaCorsi();
                await this.caricaPagina();
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                console.log(`error.response try/catch = ${error.response}`);
                console.log(`error.response.status try/catch = ${error.response.status}`);
                if (error.response.status == 401) {
                    await this.refreshToken();
                }
            }
        }
    },

    mounted() {
        this.main();
    },
    computed:{
        sortedCorsi:function() {
            return this.corsi.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            });
        },
    }
  };
</script>
<style scoped>
    td[id^="container"] {
        margin: 30px;
        width: 10px;
        height: 10px;
    }

</style>
  